import { render, staticRenderFns } from "./ProductInvestment.vue?vue&type=template&id=74e74a37&scoped=true&"
import script from "./ProductInvestment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ProductInvestment.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ProductInvestment.vue?vue&type=style&index=0&id=74e74a37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e74a37",
  null
  
)

export default component.exports